import usePlayfulStudent from '@/hooks/usePlayfulStudent';
import { WeeklyChallengeProvider } from '@/providers/WeeklyChallenge';
import DuelsDefault from './Default';
import DuelsPlayful from './Playful';

export function Duels(props) {
  return (
    <WeeklyChallengeProvider>
      <DuelsContent {...props} />
    </WeeklyChallengeProvider>
  );
}

function DuelsContent(props) {
  const isPlayfulStudentTheme = usePlayfulStudent();

  return isPlayfulStudentTheme ? <DuelsPlayful {...props} /> : <DuelsDefault {...props} />;
}
